/**
 * axios封装
 * 请求拦截、响应拦截、错误统一处理
 */
import axios from 'axios';
import router from '../router';
import {getCookie, setCookie,delCookie} from './cookieUtil.js';
import {Message} from 'iview'
import {Modal} from 'iview'
import aes from "./aes.js";
import rsa from "./rsa.js";
import iView from 'iview'

iView.LoadingBar.config({
    height: 10
});

/**
 * 提示函数
 */
const tip = msg => {
    // Modal.error({
    //     title: "系统提示",
    //     content: '<p style="word-break: break-all;">'+msg+'</p>'
    // });
    setTimeout(() => {
        Message.error(msg);
    }, 1000);
}

/**
 * 跳转登录页
 * 携带当前页面路由，以期在登录页面完成登录后返回当前页面
 */
const toSmeLogin = () => {
  // router.replace({
  //   path: '/login',
  //   query: {
  //     redirect: router.currentRoute.fullPath
  //   }
  // });
  window.location.href = `${global.SSO_PORTAL}/cmc/#/login`
}

const toSSOLogin = () => {
  // window.location.href = `${global.SSO_PORTAL}/sso/index.html#/login`
  window.location.href = `${global.SSO_PORTAL}/cmc/#/login`
}

const sessionFailed = () => {
  // 如果是冠闵 跳转到sso登录页
    if(getCookie(global.companyId)==1){
        toSSOLogin();
    }else{
        toSmeLogin();
    }
}

/**
 * 请求失败后的错误统一处理
 * @param {Number} status 请求失败的状态码
 */
const errorHandle = (status, other) => {
  // 状态码判断
  switch (status) {
    // 401: 未登录状态，跳转登录页
    case 401:
      if (other) {
        tip(other);
      } else {
        tip('登录过期，请重新登录!');
      }
      sessionFailed();
      break;
    // 403 token过期
    // 清除token并跳转登录页
    case 403:
      if (other) {
        // tip(other);
      } else {
        tip('请求被禁止!');
      }
      sessionFailed();
      break;
    // 404请求不存在
    case 404:
      if (other) {
        tip(other);
      } else {
        tip('请求资源不存在!');
      }
      break;
    // 500服务器异常
    case 500:
      if (other) {
        tip(other);
      } else {
        tip('服务器异常！请重试');
      }
      break;
    default:
      if (other) {
        tip(other);
      }
  }
}

// 超时设置
var instance = axios.create();
// 请求超时重新请求次数，请求间隙
instance.defaults.retry = 3
instance.defaults.timeout = 1000 * 60 * 30
instance.defaults.retryDelay = 1000

// 设置post请求头
instance.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';
/**
 * 请求拦截器
 * 每次请求前，如果存在token则在请求头中携带token
 */
instance.interceptors.request.use(
  config => {
    // 登录流程控制中，根据本地是否存在token判断用户的登录情况
    // 但是即使token存在，也有可能token是过期的，所以在每次的请求头中携带token
    // 后台根据携带的token判断用户的登录情况，并返回给我们对应的状态码
    // 而后我们可以在响应拦截器中，根据状态码进行一些统一的操作。
    config.cancelToken = global.store.source.token;
    const userName = getCookie(global.cookieName);
    const Authorization = getCookie('Authorization');
    const companyId = getCookie(global.companyId);

    if (userName != undefined && userName != '' && Authorization != undefined && Authorization != ''&&companyId != undefined && companyId != '') {
      setCookie(global.cookieName, userName);
      setCookie('Authorization', Authorization);
      setCookie(global.companyId, companyId);
    }else if(config.url.indexOf("/sme/user/listPositionByDepartment") != -1
    || config.url.indexOf("/sme/user/sendVerificationCode") != -1
    || config.url.indexOf("/sme/user/nextStep") != -1
    ||config.url.indexOf("/sme/user/changePassword") != -1
    ||config.url.indexOf("/sme/user/codeVerify") != -1
    ||config.url.indexOf("/sme/user/sendSmsCode") != -1
    ||config.url.indexOf("/sme/user/register") != -1
    ){

    }else{
      toSmeLogin();
    }
    userName && (config.headers.userName = userName) && (config.headers.Authorization = Authorization)&& (config.headers.companyId = companyId) ;
    if(process.env.TRANSFER_ENCRYPTION=='true'){

      //该接口为案例导入接口，前端无需加密
      var exceptUrl = process.env.API_ROOT + "/sme/ticket/importFile"
      var flag = config.data instanceof URLSearchParams;
      if(!flag && config.url != exceptUrl){
        // 获取16位随机数,当做aes秘钥key
        var randomStr = aes.randomString(16);
        // aes加密
        var data = aes.encrypt(JSON.stringify(config.data), randomStr);
        // rsa加密
        var encrypted = rsa.encrypt(randomStr);
        // 创建json对象
        var json = {
          "requestData": data,
          "encrypted": encrypted
        };
        config.data = json;
      }
    }
    //开始显示LoadingBar
    iView.LoadingBar.start();
    return config;
  },
  error => {
    //失败显示LoadingBar
    iView.LoadingBar.error();
    return Promise.error(error)
  })

// 响应拦截器
instance.interceptors.response.use(
  // 请求成功
  response => {
    if(process.env.TRANSFER_ENCRYPTION=='true'){
      if (response.data.encrypted && response.data.requestData) {
        //解密aes Key
        var key = rsa.decrypt(response.data.encrypted);
        //解密返回数据
        response.data = eval('(' + aes.decrypt(response.data.requestData, key) + ')');
      }
    }
    if (response.data.code === 401) {
      tip('登录过期，请重新登录!');
      localStorage.removeItem('token')
      toSmeLogin();
    }
    if (response.status === 200) {
      //关闭显示LoadingBar
      iView.LoadingBar.finish();
      return Promise.resolve(response);
    } else {
      iView.LoadingBar.error();
      return Promise.reject(response);
    }
  },
  // 请求失败
  error => {
    const {response} = error;
    if (response) {
      if(process.env.TRANSFER_ENCRYPTION=='true'){
        if (response.data.encrypted && response.data.requestData) {
          //解密aes Key
          var key = rsa.decrypt(response.data.encrypted);
          //解密返回数据
          response.data = eval('(' + aes.decrypt(response.data.requestData, key) + ')');
        }
      }
      // 请求已发出，但是不在2xx的范围
      errorHandle(response.status, decodeURI(response.headers.message, "UTF-8"));
      iView.LoadingBar.error();
      return Promise.reject(response);
    }
  },
  config => {

  }
);

export default instance;




// WEBPACK FOOTER //
// ./src/utils/http.js